import React, { useState, useEffect, Component } from 'react';
import axios from 'axios';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import TableView from '../TableView';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Customer = () => {
    // const [baseUrl, setBaseUrl] = useState('http://127.0.0.1:8000/api/');
    const [baseUrl, setBaseUrl] = useState('http://mol.evolve-demo.com/api/');
    const [pageComponent, setPageComponent] = useState('customer');
    const [data, setData] = useState(undefined);
    const [cusCode, setCusCode] = useState('');
    const [cusName, setCusName] = useState('');
    const [shortName, setShortName] = useState('');
    const [eMail, setEMail] = useState('');
    const [phoneNo1, setPhoneNo1] = useState('');
    const [phoneNo2, setPhoneNo2] = useState('');
    const [fax, setFax] = useState('');
    const [web, setWeb] = useState('');
    const [contactPerson, setContactPerson] = useState('');
    const [contactPersonContNO, setContactPersonContNO] = useState('');
    const [addressLine1, setAddressLine1] = useState('');
    const [addressLine2, setAddressLine2] = useState('');
    const [addressLine3, setAddressLine3] = useState('');
    const [addressLine4, setAddressLine4] = useState('');
    const [city, setCity] = useState('');
    const [postalCode, setPostalCode] = useState('');
    const [stateProv, setStateProv] = useState('');
    const [country, setCountry] = useState('');
    const [gLacc, setGLacc] = useState('');
    const [payTerm, setPayTerm] = useState('');
    const [paytermList, setPaytermList] = useState(undefined);
    const [btnActive, setBtnActive] = useState(true);
    const [selectRowData, setSelectRowData] = useState('');
    const [emptyInput, setEmptyInput] = useState(false);
    const [emptyCusCode, setEmptyCusCode] = useState(false);
    const [emptyCusName, setEmptyCusName] = useState(false);
    const [emptyShortName, setEmptyShortName] = useState(false);
    const [emptyEmail, setEmptyEmail] = useState(false);
    const [emptyPhone, setEmptyPhone] = useState(false);
    const [emptyFax, setEmptyFax] = useState(false);
    const [emptyContactPerson, setEmptyContactPerson] = useState(false);
    const [emptyAddress, setEmptyAddress] = useState(false);
    const [emptyCity, setEmptyCity] = useState(false);
    const [emptyPostalCode, setEmptyPostalCode] = useState(false);
    const [emptyStateProv, setEmptyStateProv] = useState(false);
    const [emptyCountry, setEmptyCountry] = useState(false);
    const [emptyPaytermList, setEmptyPaytermList] = useState(false);
    const [emptyContactPersonContNO, setEmptyContactPersonContNO] = useState(false);


    function setSelectedRow(rowid) {
        const currunt_ID = rowid;
        console.log(currunt_ID);
        axios.get(`${baseUrl}${pageComponent}/show/${currunt_ID}`).then(res => {
            const selectRowData = res.data;
            setSelectRowData(selectRowData);
            setCusCode(selectRowData.customer.Cus_id ? selectRowData.customer.Cus_id : '');
            setCusName(selectRowData.customer.Cus_name ? selectRowData.customer.Cus_name : '');
            setShortName(selectRowData.customer.Short_name ? selectRowData.customer.Short_name : '');
            setEMail(selectRowData.customer.email ? selectRowData.customer.email : '');
            setPhoneNo1(selectRowData.customer.telephone_1 ? selectRowData.customer.telephone_1 : '');
            setPhoneNo2(selectRowData.customer.telephone_2 ? selectRowData.customer.telephone_2 : '');
            setFax(selectRowData.customer.Fax ? selectRowData.customer.Fax : '');
            setWeb(selectRowData.customer.web ? selectRowData.customer.web : '');
            setContactPerson(selectRowData.customer.Contact_person ? selectRowData.customer.Contact_person : '');
            setAddressLine1(selectRowData.customer.Address_line_1 ? selectRowData.customer.Address_line_1 : '');
            setAddressLine1(selectRowData.customer.Address_line_2 ? selectRowData.customer.Address_line_2 : '');
            setAddressLine1(selectRowData.customer.Address_line_3 ? selectRowData.customer.Address_line_3 : '');
            setAddressLine1(selectRowData.customer.Address_line_4 ? selectRowData.customer.Address_line_4 : '');
            setCity(selectRowData.customer.City ? selectRowData.customer.City : '');
            setPostalCode(selectRowData.customer.Postal_code ? selectRowData.customer.Postal_code : '');
            setStateProv(selectRowData.customer.state_prov ? selectRowData.customer.state_prov : '');
            setCountry(selectRowData.customer.Country ? selectRowData.customer.Country : '');
            setContactPersonContNO(selectRowData.customer.Contper_no ? selectRowData.customer.Contper_no : '');
            setGLacc(selectRowData.customer.GL_acc ? selectRowData.customer.GL_acc : '');
            setPayTerm(selectRowData.customer.Pay_term ? selectRowData.customer.Pay_term : '');
            setBtnActive(false);
        })
    }

    const createNewRow = () => {
        setBtnActive(false);
        setSelectRowData('');
    }

    useEffect(() => {
        fetch(`${baseUrl}${pageComponent}/dropdown`)
            .then(response => response.json())
            .then(data => {
                setPaytermList(data.payterm);
            })
            .catch(error => {
                console.error(error);
            });
    }, []);

    const handleSave = async (event) => {
        event.preventDefault();

        if (cusCode.length == 0) {
            toast.error("Customer Code can not be empty", {
                position: toast.POSITION.TOP_RIGHT
            });
            setEmptyCusCode(true);
            setEmptyInput(true);
        } else {
            setEmptyCusCode(false);
        }

        if (cusName.length == 0) {
            toast.error("Customer Name can not be empty", {
                position: toast.POSITION.TOP_RIGHT
            });
            setEmptyCusName(true);
            setEmptyInput(true);
        } else {
            setEmptyCusName(false);
        }


        if (shortName.length == 0) {
            toast.error("Customer ShortName can not be empty", {
                position: toast.POSITION.TOP_RIGHT
            });
            setEmptyShortName(true);
            setEmptyInput(true);
        } else {
            setEmptyShortName(false);
        }

        if (eMail.length == 0) {
            toast.error("Customer Email can not be empty", {
                position: toast.POSITION.TOP_RIGHT
            });
            setEmptyEmail(true);
            setEmptyInput(true);
        } else {
            setEmptyEmail(false);
        }

        if (phoneNo1.length == 0) {
            toast.error("Customer Phone number can not be empty", {
                position: toast.POSITION.TOP_RIGHT
            });
            setEmptyPhone(true);
            setEmptyInput(true);
        } else {
            setEmptyPhone(false);
        }

        if (fax.length == 0) {
            toast.error("Customer Fax number can not be empty", {
                position: toast.POSITION.TOP_RIGHT
            });
            setEmptyFax(true);
            setEmptyInput(true);
        } else {
            setEmptyFax(false);
        }

        if (addressLine1.length == 0) {
            toast.error("Customer Address can not be empty", {
                position: toast.POSITION.TOP_RIGHT
            });
            setEmptyAddress(true);
            setEmptyInput(true);
        } else {
            setEmptyAddress(false);
        }

        if (contactPerson.length == 0) {
            toast.error("Contact Person can not be empty", {
                position: toast.POSITION.TOP_RIGHT
            });
            setEmptyContactPerson(true);
            setEmptyInput(true);
        } else {
            setEmptyContactPerson(false);
        }

        if (city.length == 0) {
            toast.error("Customer City can not be empty", {
                position: toast.POSITION.TOP_RIGHT
            });
            setEmptyCity(true);
            setEmptyInput(true);
        } else {
            setEmptyCity(false);
        }

        if (postalCode.length == 0) {
            toast.error("Postal code can not be empty", {
                position: toast.POSITION.TOP_RIGHT
            });
            setEmptyPostalCode(true);
            setEmptyInput(true);
        } else {
            setEmptyPostalCode(false);
        }

        if (stateProv.length == 0) {
            toast.error("State/Prov can not be empty", {
                position: toast.POSITION.TOP_RIGHT
            });
            setEmptyStateProv(true);
            setEmptyInput(true);
        } else {
            setEmptyStateProv(false);
        }

        if (country.length == 0) {
            toast.error("Country can not be empty", {
                position: toast.POSITION.TOP_RIGHT
            });
            setEmptyCountry(true);
            setEmptyInput(true);
        } else {
            setEmptyCountry(false);
        }

        if (paytermList.length == 0) {
            toast.error("Payment Term can not be empty", {
                position: toast.POSITION.TOP_RIGHT
            });
            setEmptyPaytermList(true);
            setEmptyInput(true);
        } else {
            setEmptyPaytermList(false);
        }

        if (contactPersonContNO.length == 0) {
            toast.error("Payment Term can not be empty", {
                position: toast.POSITION.TOP_RIGHT
            });
            setEmptyContactPersonContNO(true);
            setEmptyInput(true);
        } else {
            setEmptyContactPersonContNO(false);
        }

        if (emptyInput !== true) {
            const inputData = { Cus_id: cusCode, Short_name: shortName, Cus_name: cusName, Address_line_1: addressLine1, Address_line_2:addressLine2, Address_line_3 : addressLine3, Address_line_4: addressLine4, City: city, state_prov: stateProv, Postal_code: postalCode, Country: country, telephone_1: phoneNo1, telephone_2: phoneNo2, Fax: fax, email: eMail, web: web, Contact_person: contactPerson, Contper_no: contactPersonContNO, Pay_term: payTerm };
            const duplicate = await data.some(el => el.Code == cusCode);
            if (duplicate !== true) {

                axios.post(`http://mol.evolve-demo.com/api/customer/store`, inputData)
                    .then(response => {
                        toast.success('Successfully Save Data ! ', {
                            position: toast.POSITION.TOP_RIGHT
                        });
                        setTimeout(window.location.reload.bind(window.location), 2000);

                    })
                    .catch(error => {
                        console.error(error);
                    });
            } else {

                toast.error("This currency code already included", {
                    position: toast.POSITION.TOP_RIGHT
                })


            }
        } else {

        }
    }

    const edditRow = (event) => {
        event.preventDefault();
        if (selectRowData !== '') {
            const inputData = { Cus_id: cusCode, Short_name: shortName, Cus_name: cusName, Address_line_1: addressLine1, Address_line_2:addressLine2, Address_line_3 : addressLine3, Address_line_4: addressLine4, City: city, state_prov: stateProv, Postal_code: postalCode, Country: country,  telephone_1: phoneNo1, telephone_2: phoneNo2, Fax: fax, email: eMail, web: web, Contact_person: contactPerson, Contper_no: contactPersonContNO, Pay_term: payTerm };
            axios.post(`${baseUrl}${pageComponent}/${selectRowData.customer.id}/update`, inputData)
                .then(response => {
                    console.log(response.data);
                    window.location.reload(false);
                    alert('Successfully Save Data');
                })
                .catch(error => {
                    console.error(error);
                });
        } else {
            toast.error("Please Select data Row", {
                position: toast.POSITION.TOP_RIGHT
            })
        }
    }

    const deleteRow = (event) => {
        event.preventDefault();
        console.log(selectRowData.customer.id);
        axios.delete(`${baseUrl}${pageComponent}/${selectRowData.customer.id}/destroy`, selectRowData.customer.id)
            .then(alert('Successfully Deleted Data Row'));
        window.location.reload(false);
    }

    useEffect(() => {
        fetch(`${baseUrl}${pageComponent}/index`)
            .then(response => response.json())
            .then(data => {
                setData(data.customer);
                console.log(data.customer);
            })
            .catch(error => {
                console.error(error);
            });
    }, []);

    const columns = ['Cus_id', 'Short_name', 'Cus_name', 'Address', 'City', 'state_prov', 'Postal_code', 'Country', 'Phone_no', 'Fax', 'email', 'web', 'Contact_person', 'Contper_no', 'Pay_term'];
    return (
        <Container>
            <ToastContainer autoClose={2000} />
            <Row>
                <Col>
                    <Form className='mt-3 bottom-border pb-3'>
                        <Row >
                            <Col>
                                <Form.Group className="mb-3" controlId="formGroupEmail">
                                    <Form.Label>Code</Form.Label>
                                    <Form.Control type="text" placeholder="" readOnly={selectRowData !== '' ? true : false} className={emptyCusCode == true ? 'border-red2' : ''} value={cusCode} onChange={e => setCusCode(e.target.value)} />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="formGroupEmail">
                                    <Form.Label>Name</Form.Label>
                                    <Form.Control type="text" placeholder="" className={emptyCusName == true ? 'border-red2' : ''} value={cusName} onChange={e => setCusName(e.target.value)} />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="formGroupEmail">
                                    <Form.Label>Short Name</Form.Label>
                                    <Form.Control type="text" placeholder="" className={emptyShortName == true ? 'border-red2' : ''} value={shortName} onChange={e => setShortName(e.target.value)} />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="formGroupEmail">
                                    <Form.Label>E-mail</Form.Label>
                                    <Form.Control type="email" placeholder="" className={emptyEmail == true ? 'border-red2' : ''} value={eMail} onChange={e => setEMail(e.target.value)} />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="formGroupEmail">
                                    <Form.Label>Telephone</Form.Label>
                                    <Form.Control type="phone" placeholder="" className={emptyPhone == true ? 'border-red2' : ''} value={phoneNo1} onChange={e => setPhoneNo1(e.target.value)} />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="formGroupEmail">
                                    <Form.Label>Telephone</Form.Label>
                                    <Form.Control type="phone" placeholder="" value={phoneNo2} onChange={e => setPhoneNo2(e.target.value)} />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row >
                            <Col>
                                <Form.Group className="mb-3" controlId="formGroupEmail">
                                    <Form.Label>Fax</Form.Label>
                                    <Form.Control type="phone" placeholder="" value={fax} className={emptyFax == true ? 'border-red2' : ''} onChange={e => setFax(e.target.value)} />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="formGroupEmail">
                                    <Form.Label>Web Site</Form.Label>
                                    <Form.Control type="text" placeholder="" value={web} onChange={e => setWeb(e.target.value)} />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="formGroupEmail">
                                    <Form.Label>Contact Person</Form.Label>
                                    <Form.Control type="text" placeholder="" value={contactPerson} className={emptyContactPerson == true ? 'border-red2' : ''} onChange={e => setContactPerson(e.target.value)} />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="formGroupEmail">
                                    <Form.Label>Address</Form.Label>
                                    {/* <Form.Control as="textarea" placeholder="Address here" className={emptyAddress == true ? 'border-red2' : ''} value={address} onChange={e => setAddress(e.target.value)} /> */}
                                    <Form.Control type="text" placeholder="" value={addressLine1} className={emptyAddress == true ? 'border-red2' : ''} onChange={e => setAddressLine1(e.target.value)} />
                                    <Form.Control type="text" placeholder="" value={addressLine2} onChange={e => setAddressLine2(e.target.value)} />
                                    <Form.Control type="text" placeholder="" value={addressLine3} onChange={e => setAddressLine3(e.target.value)} />
                                    <Form.Control type="text" placeholder="" value={addressLine4} onChange={e => setAddressLine4(e.target.value)} />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="formGroupEmail">
                                    <Form.Label>City</Form.Label>
                                    <Form.Control type="text" placeholder="" value={city} className={emptyCity == true ? 'border-red2' : ''} onChange={e => setCity(e.target.value)} />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row >
                            <Col>
                                <Form.Group className="mb-3" controlId="formGroupEmail">
                                    <Form.Label>Postal Code</Form.Label>
                                    <Form.Control type="text" placeholder="" value={postalCode} className={emptyPostalCode == true ? 'border-red2' : ''} onChange={e => setPostalCode(e.target.value)} />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="formGroupEmail">
                                    <Form.Label>State/Prov</Form.Label>
                                    <Form.Control type="text" placeholder="" value={stateProv} className={emptyStateProv == true ? 'border-red2' : ''} onChange={e => setStateProv(e.target.value)} />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="formGroupEmail">
                                    <Form.Label>Country</Form.Label>
                                    <Form.Control type="text" placeholder="" value={country} className={emptyCountry == true ? 'border-red2' : ''} onChange={e => setCountry(e.target.value)} />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="formGroupEmail">
                                    <Form.Label>Payment Term</Form.Label>

                                    <Form.Select aria-label="Default select example" className={emptyPaytermList == true ? 'border-red2' : ''} onChange={e => setPayTerm(e.target.value)}>
                                        {payTerm !== '' ?
                                            <>
                                                <option value={payTerm} >{payTerm}</option>
                                                {paytermList !== undefined ? paytermList.map(paytermItem => (
                                                    paytermItem.PaymentTerm !== payTerm ?
                                                        <option value={paytermItem.PaymentTerm} key={paytermItem.id}>{paytermItem.PaymentTerm}</option>
                                                        : ''
                                                )) : ''}
                                            </>
                                            :
                                            <>
                                                <option value={payTerm} >{payTerm}</option>
                                                {paytermList !== undefined ? paytermList.map(paytermItem => (

                                                    <option value={paytermItem.PaymentTerm} key={paytermItem.id}>{paytermItem.PaymentTerm}</option>
                                                )) : ''}
                                            </>
                                        }

                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="formGroupEmail">
                                    <Form.Label>Contact Telephone</Form.Label>
                                    <Form.Control type="text" placeholder="" value={contactPersonContNO} className={emptyContactPersonContNO == true ? 'border-red2' : ''} onChange={e => setContactPersonContNO(e.target.value)} />
                                </Form.Group>
                            </Col>

                        </Row>
                        <Row className='text-center mt-3'>
                            <Col>
                                <Form className="d-flex">
                                    <Form.Control
                                        type="search"
                                        placeholder="Search"
                                        className="me-2"
                                        aria-label="Search"
                                    />
                                    <Button className="ms-3" variant="primary" type="submit">
                                        Search
                                    </Button>
                                </Form>
                            </Col>
                            <Col className='text-end'>
                                <Button className="ms-3" variant="primary" onClick={selectRowData !== '' ? edditRow : handleSave} disabled={btnActive}>
                                    Save
                                </Button>

                                <Button className="ms-3" variant="primary" onClick={createNewRow}>
                                    New
                                </Button>

                                <Button className="ms-3" variant="primary" onClick={edditRow} disabled={btnActive}>
                                    Update
                                </Button>
                                <Button className="ms-3" variant="primary" onClick={deleteRow} disabled={btnActive}>
                                    Delete
                                </Button>

                                <Button className="ms-3" variant="primary" disabled={btnActive}>
                                    Print
                                </Button>

                                <Button className="ms-3" variant="primary" type="submit">
                                    Cancel
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                </Col>
            </Row>
            <Row className='mt-4'>
                <Col>
                    <TableView data={data} columns={columns} setSelectedRow={setSelectedRow} />
                </Col>
            </Row>
        </Container>
    );
}

export default Customer;